import React from "react";
import Typography from "@material-ui/core/Typography";

const NotFound = () => {
  return (
    <div>
      <Typography variant="title" align="center">
        404 | Not found
      </Typography>
    </div>
  );
};

export default NotFound;



// WEBPACK FOOTER //
// ./src/pages/NotFound.js